import React, { useEffect, useState } from 'react'
import { authenticationService,Help, Input } from '@enkla-gui'
import { core } from '@config'
import { useForm } from 'react-hook-form'
import { useHistory, useParams } from 'react-router-dom'

export default function Register() {
  const { register, handleSubmit } = useForm()
  const history = useHistory()
  const [error, setError] = useState(null)
  const [modal, setModal] = useState(null)
  const [cookieModal, setCookieModal] = useState(null)
  const [registering, setRegistering] = useState(false)
	const [name, setName] = useState('')
	const { invite } = useParams()
  if (authenticationService.currentTokenValue !== null) history.push('/dashboard')
  var onSubmit = data => {
    setRegistering(true)
    authenticationService
      .register({ ...data, tos_accepted: true })
      .then(user => {
        history.push({
          pathname: '/login',
          message: 'Kontot registrerat, vi har skickat ett mail med länk för verifiering av e-post'
        })
      })
      .catch(([error, res]) => {
        setRegistering(false)
        setError({
          message: res.message,
          data: res.data
        })
      })
  }
	useEffect(() => {
		window.fetch(`${core.server}api/invite/${invite}`).then(res => res.json()).then(res => {
			if (res) {
				setName(res.name)
			}
		})
	}, [])
  return (
    <div className='full-height register-page'>
      <div className='register-card'>
        <div className='register-card-inner'>
          <div className='register-info'>
            <div className='register-info-content'>
              <div className='register-accent-dot' />
              <span className='register-info-badge'>Inbjudan</span>

    <h2>Välkommen till Enkla Fastigheter</h2>

<p className='register-info-subtitle'>
  Du har blivit inbjuden av <strong>{name}</strong> att skapa ett konto i Enkla Fastigheter.
</p>

<p className='register-info-subtitle'>
  Slutför registreringen genom att skapa ditt konto och välja ett lösenord.
  Därefter kan du logga in och börja använda plattformen.
</p>
              <div className='register-accent-line' />
            </div>
          </div>
          <div className='register-form-section'>
            <form onSubmit={handleSubmit(onSubmit)}>
              <input type='hidden' value={invite} {...register('invite')} />
              {error && <Help type='danger' icon='fas fa-exclamation' header={false}>{error.message}</Help>}
              <Input
                controls={{ register }}
                name='user.name'
                options={{ required: true }}
                label='Ditt Namn'
                error={error}
              />
              <Input
                controls={{ register }}
                name='user.email'
                options={{ required: true }}
                label='E-post'
                error={error}
              />
              <Input
                controls={{ register }}
                name='user.password'
                options={{ required: true }}
                label='Lösenord'
                type='password'
                error={error}
              />
              <Input
                controls={{ register }}
                name='user.password_confirmation'
                options={{ required: true }}
                label='Verifiera lösenord'
                type='password'
                error={error}
              />
              <div className='mb-3'>
                {!registering ? (
                  <button type='submit' className='btn register-btn'>Registrera</button>
                ) : (
                  <button type='submit' disabled className='btn register-btn'>
                    <i className='fas fa-circle-notch fa-spin' /> Skapar konto...
                  </button>
                )}
              </div>
              <p className='register-terms'>
                Genom att klicka på <strong>Registrera</strong> godkänner du vårt{' '}
                <a href={`${process.env.PUBLIC_URL}/TOS.pdf`} target='_blank' rel='noreferrer'>användaravtal</a>.
              </p>
            </form>
          </div>
        </div>
      </div>
      <p className='register-login-link'>
        Har du redan ett konto? <a href='#/login'>Logga in istället</a>
      </p>
    </div>
  )
}
